exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login {\n  padding: 100px 0 50px 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow-y: auto;\n  background: url(\"/static/webapp/images/signin-bg.png\") no-repeat center center fixed;\n  background-size: cover;\n}\n@supports (-webkit-touch-callout: none) {\n  .login input {\n    font-size: 16px;\n  }\n}\n.login .login-content {\n  width: 320px;\n  margin: auto;\n  text-align: center;\n}\n.login .login-content .logo {\n  height: 73px;\n  margin-bottom: 50px;\n}\n.login .login-content .floating-form {\n  padding: 45px 45px 20px;\n  border-radius: 6px;\n  position: relative;\n  background-color: #fff;\n  -webkit-box-shadow: 0 4px 5px 2px rgba(0,0,0,0.2);\n          box-shadow: 0 4px 5px 2px rgba(0,0,0,0.2);\n}\n.login .login-content .floating-form a {\n  color: #0152cc;\n  font-size: 11px;\n  text-align: right;\n}\n.login .login-content .floating-form a:hover {\n  text-decoration: underline;\n}\n.login .login-content .floating-form .is-input {\n  margin-bottom: 15px;\n}\n.login .login-content .floating-form .is-button {\n  width: 100%;\n}\n.login .login-content .floating-form .inline-button {\n  color: #0152cc;\n  margin-top: 15px;\n  padding: 10px;\n  text-align: center;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.login .login-content .floating-form .separator-container {\n  color: #aaa;\n  width: 100%;\n  margin: 30px 0;\n  border-bottom: 1px solid #aaa;\n  line-height: 0.1em;\n  text-align: center;\n}\n.login .login-content .floating-form .separator-container > span {\n  font-size: 13px;\n  padding: 0 15px;\n  background: #fff;\n}\n.login .login-content .floating-form .privacy-police {\n  color: #999;\n  font-size: 11px;\n  margin-top: 24px;\n}\n.login .login-content .floating-form .alternative-auth {\n  color: #464646;\n  font-size: 14px;\n  width: 100%;\n  margin-bottom: 12px;\n  padding: 8px 12px;\n  border: 1px solid #aaa;\n  border-radius: 4px;\n  display: block;\n  background-color: #fff;\n  text-align: left;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.login .login-content .floating-form .alternative-auth:hover {\n  border-color: #0152cc;\n}\n.login .login-content .floating-form .alternative-auth a {\n  color: #464646;\n  display: block;\n  text-decoration: none;\n}\n.login .login-content .floating-form .alternative-auth img {\n  width: 16px;\n  margin-right: 8px;\n}\n.login .login-content .floating-form .awards-container {\n  margin-top: 32px;\n}\n.login .login-content .floating-form .awards-container img {\n  -webkit-filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.25));\n          filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.25));\n}\n.login .newPasswordLabel {\n  font-size: 13px;\n  margin: 1em 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n", ""]);

// exports
exports.locals = {
	"chart_blue": "#3d73ff",
	"chart_green": "#97ce60",
	"chart_purple": "#8565ff",
	"chart_yellow": "#ffc55b",
	"chart_lavender": "#8d99ff",
	"chart_navy": "#0941a1",
	"chart_skyBlue": "#9ddfff",
	"chart_teal": "#059dde",
	"chart_cyan": "#00caff",
	"chart_violet": "#c585ea",
	"chart_coral": "#ff9a9e",
	"chart_mint": "#52baaa",
	"chart_pink": "#ef3b51",
	"chart_lime": "#e5e925",
	"chart_orange": "#ff8e38",
	"chart_burgundy": "#883955",
	"chart_blue_hover": "#3866e0",
	"chart_green_hover": "#80ae61",
	"chart_purple_hover": "#715ae0",
	"chart_yellow_hover": "#d3a75d",
	"chart_lavender_hover": "#7884e0",
	"chart_navy_hover": "#163982",
	"chart_skyBlue_hover": "#84bce0",
	"chart_teal_hover": "#0b87c5",
	"chart_cyan_hover": "#07abe0",
	"chart_violet_hover": "#a474cf",
	"chart_coral_hover": "#d38592",
	"chart_mint_hover": "#489e9c",
	"chart_pink_hover": "#c63955",
	"chart_lime_hover": "#bec431",
	"chart_orange_hover": "#d37b41",
	"chart_burgundy_hover": "#743758",
	"zIndexModal": "1000",
	"zIndexModalX": "1001",
	"zScrollToTopButton": "99",
	"zIndexRCTopBar": "4",
	"baseMargin": "15px",
	"cardPadding": "25px",
	"navigationHeight": "70px",
	"resolutionListWidth": "408px",
	"collapsedResolutionListWidth": "300px",
	"primaryColor": "#2f354a",
	"contrastColor": "#bad2de",
	"contrastLightColor": "#ebf2f6",
	"warningColor": "#ffa800",
	"secondaryColor": "#0152cc",
	"textGray": "#888",
	"borders": "#e5e5e5",
	"linksColor": "#00afff",
	"red": "#f83a32",
	"gray": "#bdbdbd",
	"grayLight": "#eaeaea",
	"green": "#4caf50",
	"blackish": "#1c1f24",
	"priorityLow": "#2cdadf",
	"priorityMedium": "#ffb13a",
	"priorityHigh": "#e44258",
	"modalBackgroundColor": "rgba(47,53,74,0.851)",
	"zIndexDropdown": "6",
	"zIndexStickyHeaders": "5",
	"zIndexTableRow": "2",
	"rcTabletPoint": "1050px",
	"rcTabletPointMin": "1051px",
	"rcPhonePointMin": "751px",
	"rcPhonePoint": "750px",
	"rcCollapseListPoint": "1420px",
	"rcCollapseReportAction": "1700px",
	"incidentLabelBackgroundColor": "#beebf1",
	"incidentLabelBackgroundColorAC": "#dfd1e7",
	"incidentLabelColor": "#317680",
	"incidentLabelColorAC": "#5f456d",
	"borderRadius": "4px",
	"roundButtonRadius": "100px",
	"squareButtonRadius": "4px",
	"cardBorderColor": "#e6e9ee",
	"cardSubtitleFontSize": "18px",
	"negativeColor": "#e44258",
	"negativeColorDark": "#b63546",
	"positiveColor": "#00c875",
	"warningColorLight": "#ffd95b",
	"bold": "700",
	"semibold": "600",
	"regular": "400",
	"ds_buttonHover": "#1d2cb2",
	"danger_buttonHover": "#b63546",
	"ds_gray_1": "#2f354a",
	"ds_gray_2": "#565b6d",
	"ds_gray_3": "#777d8e",
	"ds_gray_4": "#8e8fa0",
	"ds_gray_5": "#aaabb8",
	"ds_gray_6": "#c5c7d0",
	"ds_gray_7": "#e6e9ee",
	"ds_gray_8": "#f5f6f8",
	"ds_gray_9": "#fafbfc",
	"white": "#fff",
	"ds_bg_darkBlue": "#223063",
	"ds_bg_navyBlue": "#414e7c",
	"ds_bg_periwinkle": "#546296",
	"ds_bg_paleBlue": "#e6e9ff",
	"ds_bg_lightPink": "#fae5e1",
	"ds_blue_1": "#003385",
	"ds_blue_2": "#1948d2",
	"ds_blue_3": "#9fc7ff",
	"ds_blue_4": "#c1cef4",
	"ds_blue_5": "#d3deff",
	"ds_blue_6": "#dae4f7",
	"ds_blue_7": "#eaefff",
	"ds_blue_8": "#f2f5fe",
	"chart_1": "#3d73ff",
	"chart_2": "#97ce60",
	"chart_3": "#8565ff",
	"chart_4": "#ffc55b",
	"chart_5": "#8d99ff",
	"chart_7": "#9ddfff",
	"chart_6": "#0941a1",
	"chart_8": "#059dde",
	"chart_9": "#00caff",
	"chart_10": "#c585ea",
	"chart_11": "#ff9a9e",
	"chart_12": "#52baaa",
	"chart_13": "#ef3b51",
	"chart_14": "#e5e925",
	"chart_15": "#ff8e38",
	"chart_16": "#883955",
	"chart_hover_1": "#3866e0",
	"chart_hover_2": "#80ae61",
	"chart_hover_3": "#715ae0",
	"chart_hover_4": "#d3a75d",
	"chart_hover_5": "#7884e0",
	"chart_hover_6": "#163982",
	"chart_hover_7": "#84bce0",
	"chart_hover_8": "#0b87c5",
	"chart_hover_9": "#07abe0",
	"chart_hover_10": "#a474cf",
	"chart_hover_11": "#d38592",
	"chart_hover_12": "#489e9c",
	"chart_hover_13": "#c63955",
	"chart_hover_14": "#bec431",
	"chart_hover_15": "#d37b41",
	"chart_hover_16": "#743758",
	"primary": "#3063fd",
	"buttonHover": "#2e41ea",
	"highRisk": "#f6393c",
	"mediumRisk": "#ef6e22",
	"lowRisk": "#316d1e",
	"bodyText": "14px",
	"mainText": "32px",
	"titleText": "24px",
	"subtitleText": "24px",
	"paragraphText": "16px",
	"captionText": "12px",
	"labelText": "13px",
	"errorText": "12px",
	"brandColor": "#2e41ea"
};